import { ActivityType, ApiViewMode, ViewMode } from './enums/ActivityCalendar.enum';
import { ITypeMeta } from './interfaces/ITypeMeta';

export const API_VIEW_MODE: Record<ViewMode, ApiViewMode> = {
  [ViewMode.Week]: ApiViewMode.Week,
  [ViewMode.Month]: ApiViewMode.Month,
  [ViewMode.Year]: ApiViewMode.Year,
};

export const TYPE_META: ITypeMeta[] = [
  { key: ActivityType.Spray, label: 'Spray Records', color: '#2d855f', bg: '#e3f1ea', fg: '#1f6b49' },
  { key: ActivityType.Dry, label: 'Dry Application', color: '#e29200', bg: '#fdf3dc', fg: '#8a5a00' },
  { key: ActivityType.Fertigation, label: 'Fertigation', color: '#0284c7', bg: '#e0f2fe', fg: '#075985' },
];

export const getTypeMeta = (key: ActivityType): ITypeMeta =>
  TYPE_META.find((t) => t.key === key) as ITypeMeta;

export const ACTIVITY_TYPE_SORT_ORDER = [ActivityType.Spray, ActivityType.Dry, ActivityType.Fertigation];

export const typeOrder = (key: ActivityType): number => ACTIVITY_TYPE_SORT_ORDER.indexOf(key);

export const CALENDAR_MONTH_WINDOW_EACH_SIDE = 12;
export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_WEEK = 7;
export const DAYS_TO_END_OF_WEEK = DAYS_PER_WEEK - 1;
export const FIRST_DAY_OF_MONTH = 1;
export const FIRST_DAY_OF_YEAR = 1;
export const LAST_DAY_OF_YEAR = 31;
export const FIRST_MONTH_INDEX = 0;
export const LAST_MONTH_INDEX = MONTHS_PER_YEAR - 1;
export const MILLISECONDS_PER_DAY = 86400000;
export const MONDAY_FIRST_WEEK_OFFSET = 6;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const ALL_FARMS_FILTER = 'all';

export const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const MONTHS_FULL = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const TOKENS = {
  primary: '#2D855F',
  surfaceMist: '#F4FAF6',
  surfaceSunken: '#F7F8F5',
  textStrong: '#1F2937',
  textMuted: '#6B7280',
  gray400: '#9CA3AF',
  gray100: '#F2F2F2',
  borderSubtle: '#E5E7EB',
  borderField: '#D6DED6',
  borderBrand: '#A9D0BE',
  focusRing: 'rgb(45 133 95 / 0.2)',
  green700: '#2d855f',
  green50: '#e3f1ea',
  gold600: '#e29200',
  gold50: '#fdf3dc',
} as const;
